import WarehouseDetail from './WarehouseDetail';
import { useParams } from 'react-router';
import { Box } from '@mui/material';
import WarehousePurchase from './WarehousePurchase';
import WarehouseOther from './WarehouseOther';
import { ActionType } from './Enums/ActionType';
import WarehousesMainPage from './WarehousesMainPage';
import { useWarehousesPermissionContext } from '../../../Contexts/Permissions/WarehousesPermissionContext';
import { useEffect } from 'react';

interface WarehousesProps {
    type: 'warehouses' | 'products' | 'categories' | 'manufacturers' | 'detail' | 'new' | 'purchase' | 'block' | 'out' | 'utility' | 'writeoff';
}

export default function Warehouses({ type }: Readonly<WarehousesProps>) {
    const { permissions, reloadPermissions } = useWarehousesPermissionContext();
    const params = useParams();

    useEffect(() => {
        if (permissions === null) {
            reloadPermissions();
        }
    }, [reloadPermissions, permissions]);

    return (
        <Box>
            {type === 'warehouses' && <WarehousesMainPage selectedTabIndex={0} />}
            {type === 'products' && <WarehousesMainPage selectedTabIndex={1} />}
            {type === 'categories' && <WarehousesMainPage selectedTabIndex={2} />}
            {type === 'manufacturers' && <WarehousesMainPage selectedTabIndex={3} />}
            {type === 'detail' && <WarehouseDetail warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} />}
            {type === 'new' && <WarehouseDetail warehouseId={undefined} />}
            {type === 'purchase' && <WarehousePurchase warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} pStockListId={params.stockListId ? parseInt(params.stockListId) : undefined} />}
            {type === 'block' && <WarehouseOther buildingId={params.buildingId ? parseInt(params.buildingId) : undefined} warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} pStockListId={params.stockListId ? parseInt(params.stockListId) : undefined} actionType={ActionType.Block} />}
            {type === 'out' && <WarehouseOther buildingId={params.buildingId ? parseInt(params.buildingId) : undefined} warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} pStockListId={params.stockListId ? parseInt(params.stockListId) : undefined} actionType={ActionType.Out} />}
            {type === 'utility' && <WarehouseOther warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} pStockListId={params.stockListId ? parseInt(params.stockListId) : undefined} actionType={ActionType.Utility} />}
            {type === 'writeoff' && <WarehouseOther warehouseId={params.warehouseId ? parseInt(params.warehouseId) : undefined} pStockListId={params.stockListId ? parseInt(params.stockListId) : undefined} actionType={ActionType.WriteOff} />}
        </Box>
    )
}